import type { JSONSchema7 } from 'json-schema';
import jsonSchema from '../../../../schema/schema.json';

export const SCHEMA = jsonSchema as JSONSchema7;
